
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import cseh from "../../assets/cseh.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function CsehMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Cseh magyar fordító</title>
                <meta name='description' content="Ingyenes cseh magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Cseh magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/cseh-magyar-fordito" />
            </Helmet>
            <h1>Cseh magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>
                <div className="sectionhead">
                    <h2>A cseh nyelv</h2>
                    <img src={cseh} alt="cseh-zaszlo"></img>
                </div>

                <p>A cseh egy nyugati szláv nyelv, amelyet több mint 10 millió ember beszél, elsősorban a Cseh Köztársaságban. A szomszédos országok cseh közösségei és a külföldre szakadt közösségek is értik és beszélik világszerte. Itt egy áttekintés a cseh nyelvről:</p>

                <p><b>Történelmi háttér</b>: A cseh nyelv a szláv nyelvcsaládba tartozik, amelyhez olyan nyelvek is tartoznak, mint a lengyel, a szlovák és az orosz. A proto-szláv nyelvből fejlődött ki, és szoros nyelvi rokonságban áll a szlovák nyelvvel. A cseh nyelv legkorábbi írásos emlékei a 12. századból származnak.</p>

                <p><b>Nyelvi jellemzők</b>: A cseh nyelv összetett nyelvtani szerkezettel rendelkezik, részletes deklinációs és konjugációs rendszerrel. Ez egy erősen flektált nyelv, a főnevek deklinációinak és az igék ragozásának gazdag rendszerével. A cseh főneveknek hét esete van, köztük a névmás, a genitivus, a dativus, az akkuzatív, a vokativus, a lokativus és az instrumentális. Az igék személy, szám, idő és mód szerint konjugálódnak.</p>

                <p><b>Latin írás</b>: A cseh nyelvet latin betűkkel írják, némi módosítással. Az ábécé 42 betűből áll, beleértve az olyan diakritikus jeleket, mint a háček (ˇ) és čárka (´), amelyek a magánhangzó hosszát és a hangváltozásokat jelzik. Ezek a diakritikus jelek alapvető szerepet játszanak a szavak kiejtésében és jelentésében.</p>

                <p><b>Kiejtés</b>: A cseh nyelv hangtani rendszere viszonylag egyszerű kiejtéssel rendelkezik. A hangok gazdag tárházával rendelkezik, beleértve a hosszú és rövid időtartamú magánhangzókat, mássalhangzó-halmazokat és olyan jellegzetes hangokat, mint az ř (a háčeki r néven ismert), amelyek elsajátítása kihívást jelenthet a nem anyanyelvi beszélők számára.</p>

                <p><b>Nyelvjárások</b>: A cseh nyelvnek számos regionális dialektusa van, amelyek szókincsben, kiejtésben és nyelvtanban különböznek egymástól. A legjelentősebb nyelvjárási felosztás a cseh nyelvjárások (Csehországban beszélt) és a morva nyelvjárások (Morvaországban beszélt) között van. Ezeken a régiókon belül további alosztályok léteznek, amelyek az egyes településeken alapulnak.</p>

                <p><b>Kulturális jelentőség</b>: A cseh nyelv mély kulturális jelentőséggel bír a cseh nép számára. A cseh irodalom hosszú és gazdag hagyományokkal rendelkezik, olyan neves szerzőkkel, mint Franz Kafka, Milan Kundera és Bohumil Hrabal, akik jelentős mértékben hozzájárultak a világirodalomhoz. A nyelv a cseh folklór, dalok és hagyományok szerves részét képezi.</p>

                <p><b>Modern használat</b>: A cseh nyelv a Cseh Köztársaság hivatalos nyelve, és széles körben használják az oktatásban, a közigazgatásban, a médiában és az irodalomban. Az iskolákban és egyetemeken ez az oktatási médium. Bár a városi területeken egyre inkább beszélik és értik az angolt, különösen a fiatalabb generációk körében, a cseh nyelv ismerete továbbra is elengedhetetlen a cseh társadalomba való beilleszkedéshez.</p>

                <p>A cseh nyelv egyedülálló és kifejező nyelv, gazdag kulturális örökséggel. Összetett nyelvtana, regionális dialektusai és irodalmi hagyományai a nyelvtanulók és kutatók számára is érdekes témává teszik. Akár üzleti, utazási vagy személyes érdekből tanulja a cseh nyelvet, a cseh nyelvtanulás kaput kínál a Cseh Köztársaság történelmének, kultúrájának és népének megértéséhez.</p>
     
                <div className="sectionbottom">
                    <Link to="/magyar-cseh-fordito">Magyar cseh fordító</Link>

                    <img src={cseh} alt="cseh zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
     
     
     
     
            </section>
        </>

    )
}

export default CsehMagyar;